import { ProjectExternalLink } from "@planzone/dto";

function removeLinkFromAttr(
  attributes: { [key: string]: string },
  link: ProjectExternalLink,
): { [key: string]: string } {
  return Object.entries(attributes || {}).reduce(
    (nextPreferences, [key, value]) =>
      key !== `link.${link.name}.url` || key !== `link.${link.name}.name`
        ? {
            ...nextPreferences,
            [key]: value,
          }
        : nextPreferences,
    {},
  );
}

export { removeLinkFromAttr };
